import moment from 'moment'

export default {
  created() {
    if (!this.credencial) {
      throw new Error('Para poder usar el mixin "credentialProps", debe existir la propiedad "credencial"')
    }
  },

  computed: {
    documento() {
      return this.credencial.afiliado.documento
    },

    nroCredencial() {
      return this.credencial.numero
    },

    nombreCompleto() {
      return `${this.credencial.afiliado.apellido}, ${this.credencial.afiliado.nombre}`
    },

    contrato() {
      return this.credencial.afiliado.contrato
    },

    integrante() {
      return this.credencial.afiliado.integrante
    },

    documentoCompleto() {
      return `${this.documento.descripcion} ${this.documento.numero}`
    },

    fechaEmision() {
      return this.formatDate(this.credencial.fechaEmision)
    },

    fechaVencimiento() {
      return this.formatDate(this.credencial.fechaVencimiento)
    },

    fechaValidacion() {
      return this.credencial.fechaValidacion || ''
    },

    condicion() {
      return this.credencial.condicion.descripcion
    },
  },

  methods: {
    formatDate(date) {
      const momentDate = moment(date)

      return momentDate.isValid() ? momentDate.format('DD-MM-Y') : ''
    },
  },
}
